import { KeyValue, KeyValueDefault } from '@/main/models/common';
import { KeyValueId } from '@/main/models/common/keyValueId';
import { PartCatalogSuggestionResponse } from '@/main/models/response/partCatalogResponse';
import { isNullUndefined } from '@/main/services/utils';
import { convertImageToBase64 } from '@/main/services/utilsFile';
import { IDataPriceList } from './sectionPriceList/sectionPriceList';
import { PartsData } from '@/main/models/request';
import { currencyToNumber } from '@/main/services/utilsNumber';

export const INITIAL_FORM_STATE = {
  country: null as KeyValue | null,
  supplier: null as KeyValue | null,
  warehouse: null as KeyValue | null,
  category: null as KeyValue | null,
  subCategory: null as KeyValue | null,
  xnuupPartId: null as KeyValueId | null,
  position: null as KeyValue | null,
  sku: '',
  name: '',
  type: null as KeyValueDefault | null,
  partBrand: null as KeyValue | null,
  amount: '',
  dimensions: '',
  weight: '',
  packageContent: null as KeyValue | null,
  warrantyPeriod: '',
  color: '',
  observation: '',
  pickupTime: '',
  partNumberOem: '',
  partNumberIam: ''
};
export type IInventoryRegisterForm = typeof INITIAL_FORM_STATE;
export type IKeysInventoryRegisterForm = keyof IInventoryRegisterForm;

export const INITIAL_SUGGESTION: PartCatalogSuggestionResponse = {
  category: null,
  guidCategory: null,
  subCategory: null,
  guidSubCategory: null,
  partPIESName: null,
  guidPart: null,
  guidPartCatalog: null,
  partNumber: null,
  xnuupId: null,
  description: null,
  position: null,
  guidPosition: null,
  vehicles: null
};

export function hasShowAllPage(
  methodsInventoryRegisterScreen: any,
  vehicles: any
) {
  const keysFormSupplier: IKeysInventoryRegisterForm[] = [
    'supplier',
    'country'
  ];
  const keysFormMappingPart: IKeysInventoryRegisterForm[] = [
    'category',
    'subCategory',
    'position',
    'xnuupPartId'
  ];

  const hasAllFilledSupplier = keysFormSupplier.every(
    key => !isNullUndefined(methodsInventoryRegisterScreen.watch(key))
  );
  const hasAllFilledMappingPart = keysFormMappingPart.every(
    key => !isNullUndefined(methodsInventoryRegisterScreen.watch(key))
  );
  const hasAllFilledVehicle = vehicles.length > 0;
  const result =
    hasAllFilledSupplier && hasAllFilledMappingPart && hasAllFilledVehicle;
  return result;
}

export async function createImagesRequest(imagesPart: File[]) {
  try {
    const convertedImages = await Promise.all(
      imagesPart.map(convertImageToBase64)
    );
    const imagesRequest = convertedImages.reduce((acc, image, index) => {
      const keyImage = `image${index + 1}`;
      const dataImage =
        image?.type === 'url'
          ? image?.name
          : `data:${imagesPart[index].type};base64,${image?.base64Image}`;
      return {
        ...acc,
        [keyImage]: dataImage
      };
    }, {});

    return imagesRequest;
  } catch (error) {
    console.error(error);
  }
}

export function createPartsRequest(dataPriceList: IDataPriceList[]) {
  const formatPartsRequest = (i: IDataPriceList): PartsData => ({
    guidSupplierInventoryWarehousePrice: isNullUndefined(
      i.guidSupplierInventoryWarehousePrice
    )
      ? ''
      : i.guidSupplierInventoryWarehousePrice,
    idCompanyType: isNullUndefined(i.companyType)
      ? ''
      : String(i.companyType.key),
    guidCompany: isNullUndefined(i.company) ? '' : String(i.company.key),
    autoDeliveryPriceWithCost: currencyToNumber(
      String(i.priceAutoDeliveryWithCost)
    ),
    autoDeliveryPrice: currencyToNumber(String(i.priceAutoDeliveryWithoutCost)),
    shippingPrice: currencyToNumber(String(i.priceLogisticCompany))
  });

  return dataPriceList.map(formatPartsRequest);
}

